/**
 * Prefix for `/api/*` fetches so deployments with Vite `base` (subpath) still hit the backend.
 */
export function apiPath(path: string): string {
  const rel = path.startsWith("/") ? path : `/${path}`;
  const base = (import.meta.env.BASE_URL || "/").replace(/\/$/, "");
  return (base ? base : "") + rel;
}
